import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { MobileWorkerReportState } from '../types';
import { mobileWorkerReportsState } from './mobileWorkerReportsState';

export const mobileWorkerReportsSlice = createSlice({
  name: 'mobileWorkerReports',
  initialState: mobileWorkerReportsState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setReports(
      state,
      action: PayloadAction<MobileWorkerReportState['reports']>,
    ) {
      state.reports = action.payload;
    },
    setHiddenReports(
      state,
      action: PayloadAction<MobileWorkerReportState['hiddenReports']>,
    ) {
      state.hiddenReports = action.payload;
    },
    setRequestPendingTo(
      state,
      action: PayloadAction<MobileWorkerReportState['isRequestPending']>,
    ) {
      state.isRequestPending = action.payload;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: mobileWorkerReportsActions } = mobileWorkerReportsSlice;

/* ------- STATE SELECTORS ------- */
export const selectMobileWorkerReports = (state: RootState) =>
  state.mobileWorkerReports;

export default mobileWorkerReportsSlice.reducer;
